import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  user_type: null,
  isAuthenticated: false,
  email:null,
  authLoaded: false, 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      state.user_type = action.payload.user_type;
      state.email = action.payload.email;
      state.isAuthenticated = true;
      state.authLoaded = true;
     // ✅ Persist to localStorage
     localStorage.setItem("page", "users");
      localStorage.setItem('auth', JSON.stringify({
        isAuthenticated: true,
        token:action.payload.token,
        user_type:action.payload.user_type,
        email:action.payload.email,
      }));
    },
    logout: (state) => {
      state.token = null;
      state.user_type = null;
      state.email = null;
      state.isAuthenticated = false;
      state.authLoaded = true;
       // ❌ Clear localStorage on logout
      localStorage.removeItem('auth');
    },
     restoreAuth: (state, action) => {
      state.isAuthenticated = action.payload?.isAuthenticated || false;
      state.token = action.payload?.token;
      state.user_type = action.payload?.user_type;
      state.email = action.payload?.email;
      state.authLoaded = true;
    }
  },
});

export const { loginSuccess, logout,restoreAuth  } = authSlice.actions;
export default authSlice.reducer;
